import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { useSelector } from "react-redux";

import LoginScreen from "../LoginScreen";
import TopTab from "./views/TopTab";
import Sair from "./views/Sair";
import OAuthCallback from "../OauthCallback";

export default function Routes() {
  const accessToken = window.localStorage.getItem("accessToken");

  return (
    <Router>
      <Switch>
        {/* Nova rota para o callback do Google */}
        <Route path="/oauth" component={OAuthCallback} />
        {accessToken ? (
          <>
            <Route path="/" exact component={TopTab} />
            <Route path="/:tab" exact component={TopTab} />
            <Route path="/sair" exact component={Sair} />
          </>
        ) : (
          <Route path="/" component={LoginScreen} />
        )}
      </Switch>
    </Router>
  );
}
